import { PartialType } from '@nestjs/swagger';
import { CreateSucursaleDto } from './create-sucursal.dto';

export class UpdateSucursaleDto extends PartialType(CreateSucursaleDto) {}
